<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-phone"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-phone"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>
    <div class="edit-nationality-body">

      <div class="cannot-edit-profile-rectangle">
        @if (dialogData.showError) {
          <div  class="black yes-margin">
            <p>A required field is missing. Please fill out all required fields and try again.</p>
          </div>
        }
        <input sanitizeInputForm class="form-input"
          [(ngModel)]="dialogData.editChildAddress.HouseName"
          placeholder="House name/number:"
          >
          <br />
          <input sanitizeInputForm class="form-input"
            [(ngModel)]="dialogData.editChildAddress.AddressLine1"
            placeholder="Address line 1:"
            >
            <br />
            <input sanitizeInputForm class="form-input"
              [(ngModel)]="dialogData.editChildAddress.AddressLine2"
              placeholder="Address line 2:"
              >
              <br />
              <input sanitizeInputForm class="form-input"
                placeholder="Address line 3:"
                [(ngModel)]="dialogData.editChildAddress.AddressLine3"
                >
                <br />
                <input sanitizeInputForm class="form-input"
                  placeholder="Town/City:"
                  [(ngModel)]="dialogData.editChildAddress.CityOrTown"
                  >
                  <br />
                  <input sanitizeInputForm class="form-input"
                    placeholder="County:"
                    [(ngModel)]="dialogData.editChildAddress.County"
                    >
                    <br />
                    @if (dialogData.childPostCodeControl.invalid && dialogData.childPostCodeControl.dirty) {
                      <div class="black yes-margin">
                        <p>This information is required</p>
                      </div>
                    }
                    <input sanitizeInputForm class="form-input"
                      placeholder="Postcode:"
                      [(ngModel)]="dialogData.editChildAddress.PostCode"
                      [formControl]="dialogData.childPostCodeControl"
                      [ngClass]="{'invalid' : dialogData.showError}"
                      >
                      <br />
                      <input sanitizeInputForm class="form-input"
                        placeholder="Country:"
                        [(ngModel)]="dialogData.editChildAddress.Country"
                        >
                        <br />

                      </div>

                      <div class="btn-container nationality-button">
                        <button role="button" tabindex="0" aria-label="save" class="send-button"
                          (click)="dialogData.saveChildAddress(dialogData.editChildAddress)"
                        >Save</button>
                      </div>
                    </div>

